<template>
  <Dialog :open="open" @close="$emit('close')" width="720px">
    <template v-slot:title>
      <FlexRow full-width justify="center" align="baseline" :space="4">
        <Label size="h6" bold :text="name" />
        <FlexRow align="baseline">
          <FlexRow v-if="applicant.age" align="baseline" :space="0">
            <Label text="年齢："/>
            <Label bold :text="`${applicant.age}歳`" />
          </FlexRow>
          <FlexRow v-if="applicant.salary" align="baseline" :space="0">
            <Label text="現年収："/>
            <Label bold :text="`${applicant.salary}万円`" />
          </FlexRow>
          <FlexRow v-if="applicant.changeJobMotivation" align="baseline" :space="0">
            <Label text="転職意欲："/>
            <ChangeJobMotivationLabel :motivation="applicant.changeJobMotivation"/>
          </FlexRow>
          <FlexRow v-if="applicant.lastLoggedInAt" align="baseline" :space="0">
            <Label text="最終ログイン："/>
            <Label bold :text="fromNow(applicant.lastLoggedInAt)" />
          </FlexRow>
        </FlexRow>
      </FlexRow>
      <FlexRow justify="center">
        <Label text="を追加するリストを選択します"/>
      </FlexRow>
    </template>
    <template v-slot:default>
      <FlexRow justify="center" class="mt-n4">
        <FlexColumn width="500px">
          <FlexRow v-for="list in lists" :key="list.id" class="mb-n1">
            <SimpleCheckboxField
                :value="selected(list)"
                :name="list.name"
                hide-details
                @change="value => handleChangeSelectList(list, value)"
            />
          </FlexRow>
          <FlexRow class="mt-8">
            <TextButton
                accent
                @click="listSaveDialog=true"
            >
              新規リストを作成する
            </TextButton>
            <ApplicantListSaveDialog :open="listSaveDialog" @close="listSaveDialog=false" />
          </FlexRow>
        </FlexColumn>
      </FlexRow>
    </template>
    <template v-slot:actions>
      <FlexRow full-width justify="center">
        <TextButton
            primary
            @click="handleSave"
        >
          保存する
        </TextButton>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/components/atoms/Dialog";
import FlexRow from "@/components/atoms/FlexRow";
import Label from "@/components/atoms/Label";
import TextButton from "@/components/atoms/TextButton";
import ComponentMixin from "@/components/ComponentMixin";
import ChangeJobMotivationLabel from "@/components/molecules/ChangeJobMotivationLabel";
import {mapGetters} from "vuex";
import FlexColumn from "@/components/atoms/FlexColumn";
import SimpleCheckboxField from "@/components/atoms/SimpleCheckboxField";
import ApplicantListSaveDialog from "@/components/organisms/ApplicantListSaveDialog";
import ApiMixin from "@/ApiMixin";
export default {
  mixins: [ComponentMixin, ApiMixin],
  name: "ApplicantListSettingDialog",
  components: {ApplicantListSaveDialog, SimpleCheckboxField, FlexColumn, ChangeJobMotivationLabel, TextButton, Label, FlexRow, Dialog},
  props: {
    open: {
      type: Boolean
    },
    applicant: {
      type: Object
    }
  },
  data() {
    return {
      listSaveDialog: false,
      selectedListIds: []
    }
  },
  computed: {
    ...mapGetters("client", ["company"]),
    ...mapGetters("chatRequests", ["lists"]),
    name() {
      return `${this.applicant.id}さん`
    },
    selected() {
      return (list) => {
        return this.selectedListIds.includes(list.id)
      }
    }
  },
  methods: {
    handleSave() {
      this.applicant.listIds.forEach(id => {
        if (!this.lists.map(list => list.id).includes(id)) {
          return
        }
        if (!this.selectedListIds.includes(id)) {
          this.deleteChatRequestListApplicant(this.company.id, this.applicant.id, id)
        }
      })
      this.selectedListIds.forEach(id => {
        if (!this.applicant.listIds.includes(id)) {
          const list = this.lists.find(item => item.id === id)
          const listName = list ? list.name : undefined
          this.addChatRequestListApplicant(this.company.id, this.applicant.id, id, listName)
        }
      })
      this.$emit("close")
    },
    handleChangeSelectList(list, selected) {
      if (selected) {
        this.selectedListIds.push(list.id)
      } else {
        this.selectedListIds = this.selectedListIds.filter(id => id !== list.id)
      }
    }
  },
  watch: {
    open: {
      handler: function(value) {
        if (value) {
          this.selectedListIds.slice(0)
          this.applicant.listIds.forEach(id => {
            this.selectedListIds.push(id)
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>